import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';

const OOPS_MSG = 'Oops!';
@Injectable()
export class GlobalErrorHandlerService {
  public errorMessage = '';
  constructor(
    private toast: ToastrManager
    ) { }

  public handleError(error: HttpErrorResponse) {
    switch (error && error.status) {
      case 500:
        this.handle500Error(error);
        break;
      case 422:
        this.handle401Or422Error(error);
        break;
        case 403:
          this.handle500Error(error);
          break;
      case 401:
        this.handle401Or422Error(error);
        break;
      default:
        this.handleOtherError(error);
    }
  }

  private handle500Error(error: HttpErrorResponse) {
    const textMsg = 'Something went wrong. Try again in a few minutes';
    this.toast.errorToastr(textMsg, 'Oops!', {showCloseButton: true});
  }

  private handle401Or422Error(error: HttpErrorResponse) {
    const raw = error && error.error && (error.error.error || error.error.message || error.message);
    const showStickyIfSubscriptionMsg = (msg: string) => {
      if (!msg) { return false; }
      const m = msg.toString();
      const isSubscriptionGate = m.includes('PAID IN FULL') || m.includes('AVAILABLE ONLY TO CUSTOMERS WHO HAVE PAID');
      if (isSubscriptionGate) {
        // Use a large timeout instead of 0 to avoid library auto-dismiss bug
        this.toast.warningToastr(m, 'Subscription Not Available', { showCloseButton: true, toastTimeout: 600000 });
        return true;
      }
      return false;
    };

    if (error && error.error && Array.isArray(error.error.error)) {
      for (const val of error.error.error) {
        if (!showStickyIfSubscriptionMsg(val)) {
          // Use a large timeout instead of 0 to keep it visible
          this.toast.errorToastr(val, 'Oops!', { showCloseButton: true, toastTimeout: 600000 });
        }
      }
    } else if (raw) {
      if (!showStickyIfSubscriptionMsg(raw)) {
        this.toast.errorToastr(raw, 'Oops!', { showCloseButton: true, toastTimeout: 600000 });
      }
    } else {
      this.toast.errorToastr('Something went wrong', 'Oops!', { showCloseButton: true, toastTimeout: 600000 });
    }
  }

  private handleOtherError(error: HttpErrorResponse) {
    if (error.error.error instanceof Array) {
      for (const val of error.error.error) {
        this.toast.errorToastr(val, 'Oops!', {showCloseButton: true});
      }
    } else {
      this.toast.errorToastr(error.error.error, 'Oops!', {showCloseButton: true});
    }
  }

   // private handle404Error(error: HttpErrorResponse) {
  //   this.createErrorMessage(error);
  //   this.router.navigate(['/404']);
  // }

  // private createErrorMessage(error: HttpErrorResponse) {
  //   this.errorMessage = error.error ? error.error : error.statusText;
  // }

}
